import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquarePlus } from 'lucide-react';
import { Button } from '@/components/ui/button';

const AiAssistantFloatingButton = ({ onOpen }) => {
  return (
    <motion.div
      initial={{ scale: 0, y: 100 }}
      animate={{ scale: 1, y: 0 }}
      exit={{ scale: 0, y: 100 }}
      transition={{ type: 'spring', stiffness: 260, damping: 20 }}
      className="fixed bottom-6 right-6 z-50"
    >
      <Button
        size="lg"
        className="rounded-full p-4 shadow-xl bg-gradient-to-br from-primary to-accent hover:from-primary/90 hover:to-accent/90 text-primary-foreground"
        onClick={onOpen}
        aria-label="Open AI Assistant Chat"
      >
        <MessageSquarePlus className="h-8 w-8" />
      </Button>
    </motion.div>
  );
};

export default AiAssistantFloatingButton;